import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { vppsAPI } from "../api/api";
import { VppsActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* createVpp(action) {
    try {
        const { vpp, refreshData } = action.payload;

        yield call(() => vppsAPI.createVpp(vpp));
        ToasterService.successToast("Vpp successfully created");

        yield put({
            type: VppsActionTypes.CREATE_VPP_SUCCESS
        });

        yield put({
            type: VppsActionTypes.GET_VPPS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Vpp.");

        yield put({
            type: VppsActionTypes.CREATE_VPP_FAIL,
            message: e.message
        });
    }
}

export function* createVppWatcher() {
    yield takeLatest(VppsActionTypes.CREATE_VPP, createVpp);
}

function* deleteVpp(action) {
    try {
        const { id, refreshData } = action.payload;

        yield call(() => vppsAPI.deleteVpp(id));
        ToasterService.successToast("Video successfully deleted");

        yield put({
            type: VppsActionTypes.DELETE_VPP_SUCCESS
        });

        yield put({
            type: VppsActionTypes.GET_VPPS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error deleting Bundle.");

        yield put({
            type: VppsActionTypes.DELETE_VPP_FAIL,
            message: e.message
        });
    }
}

export function* deleteVppWatcher() {
    yield takeLatest(VppsActionTypes.DELETE_VPP, deleteVpp);
}
